// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b28b888f","667":"eaf29e31"}[chunkId] + ".chunk.js";
};